export default __webpack_public_path__ + "static/media/note-color-icon.22ff183f.svg";